import {
  FaCheckCircle,
  FaClock,
  FaPauseCircle,
  FaSpinner,
} from "react-icons/fa";
import DashboardCard from "../../Components/Comman/DashbordCard";
import { BsFillPeopleFill } from "react-icons/bs";
import { MdBusiness } from "react-icons/md";
import { RiFileUserFill } from "react-icons/ri";
import { GoProjectRoadmap } from "react-icons/go";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ProjectService } from "../../services/ProjectService";
import ToDoList from "../../Components/Comman/TodoList";
import MeetingList from "../../Components/Comman/MeetingList";
import { MeetingService } from "../../services/MeetingService";
import { FcHighPriority, FcLowPriority, FcMediumPriority } from "react-icons/fc";
export default function Dashboard() {
  const [statistics, setStatistics] = useState(null);
  const [meetingCount, setMeetingCount] = useState(null);
  
  useEffect(()=>{
    const fetchData=async()=>{
      try {
          const [statsRes,meetingsRes]=await Promise.all([
            ProjectService.getStatistics(),
            MeetingService.getTodaysMeetingCount()
          ]);
          
          setStatistics(statsRes);
          setMeetingCount(meetingsRes);
      } catch (error) {
        toast.error(error.message)
      }
    }
    fetchData();
  },[])

  return (
    <section className="py-4 px-4 ">
      <div className="flex flex-col md:flex-row gap-6 ">
        {/* Cards */}
        <div className="w-full lg:w-[60%] grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          <DashboardCard
            icon={GoProjectRoadmap}
            label="Total Projects"
            count={statistics?.totalProjects}
            to="/projects"
            bgColor="bg-teal-100"
            textColor="text-teal-700"
          />
          <DashboardCard
            icon={RiFileUserFill}
            label="Total Clients"
            count={statistics?.totalClients}
            to="/clients"
            bgColor="bg-indigo-100"
            textColor="text-indigo-700"
          />
          <DashboardCard
            icon={MdBusiness}
            label="Total Vendors"
            count={statistics?.totalVendors}
            to="/vendor"
            bgColor="bg-purple-100"
            textColor="text-purple-700"
          />
          <DashboardCard
            icon={BsFillPeopleFill}
            label="Total Employee"
            count={statistics?.totalEmployees}
            to="/employee"
            bgColor="bg-stone-100"
            borderColor="border-stone-100"
            textColor="text-stone-700"
          />
          <DashboardCard
            icon={FaCheckCircle}
            label="Completed Projects"
            count={statistics?.completedProjects}
            to="/projects"
            bgColor="bg-[#C8FFCD]"
            borderColor="border-green-100"
            textColor="text-green-700"
            status='completed'
          />
          <DashboardCard
            icon={FaSpinner}
            label="Active Projects"
            count={statistics?.inProcessProjects}
            to="/projects"
            bgColor="bg-blue-200"
            borderColor="border-blue-100"
            textColor="text-blue-700"
            status='in-progress'
          />
          <DashboardCard
            icon={FaPauseCircle}
            label="On Hold Projects"
            count={statistics?.onHoldProjects}
            to="/projects"
            bgColor="bg-yellow-100"
            borderColor="border-yellow-100"
            textColor="text-yellow-700"
            status='on-hold'
          />
          <DashboardCard
            icon={FaClock}
            label="Pending Projects"
            count={statistics?.pendingProjects}
            to="/projects"
            bgColor="bg-red-100"
            borderColor="border-red-100"
            textColor="text-red-700"
            status='pending'
          />

          <DashboardCard
            icon={FcLowPriority}
            label="Low Priority Projects"
            count={statistics?.lowPriorityProjects}
            to="/projects"
            bgColor="bg-lime-100"
            textColor="text-lime-700"
            priority="low"
          />
          <DashboardCard
            icon={FcMediumPriority}
            label="Medium Priority Projects"
            count={statistics?.mediumPriorityProjects}
            to="/projects"
            bgColor="bg-orange-100"
            textColor="text-orange-700"
            priority="medium"
          />
          <DashboardCard
            icon={FcHighPriority}
            label="High Priority Projects"
            count={statistics?.highPriorityProjects}
            to="/projects"
            bgColor="bg-rose-100"
            textColor="text-rose-700"
            priority="high"
          />
            <DashboardCard
            icon={FaSpinner}
            label="Active Priority Projects"
            count={statistics?.activePriorityProjects}
            to="/projects"
            bgColor="bg-cyan-100"
            textColor="text-cyan-700"
            priority="active"
          />


          <DashboardCard
            icon={FaPauseCircle}
            label="On-Hold Priority Projects"
            count={statistics?.onHoldPriorityProjects}
            to="/projects"
            bgColor="bg-fuchsia-200"
            textColor="text-fuchsia-700"
            priority="on-hold"
          />

        

          <DashboardCard
            icon={BsFillPeopleFill}
            label="Today's Meetings"
            count={meetingCount?.todaysmeetingCount}
            bgColor="bg-amber-100"
            borderColor="border-amber-200"
            textColor="text-amber-600"
          />
        </div>

        <div className="w-full lg:w-[40%] flex flex-col gap-2">
          <ToDoList />
          <MeetingList />
        </div>
      </div>
    </section>
  );
}
